import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["check", "pill", "groupId"]

  connect() {
    this.startingGroupId = this.groupIdTarget.value
    this.highlight()
  }

  choose(event) {
    event.preventDefault()
    const pill = event.currentTarget.closest("li")
    const ids = JSON.parse(pill.dataset.checks).map(String)
    this.startingGroupId = pill.dataset.groupId
    this.checkTargets.forEach((box) => {
      if (box.checked !== ids.includes(box.value)) {
        box.checked = !box.checked
        box.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
    this.highlight()
  }

  highlight() {
    const ticked = this.idList(this.checkTargets.filter((box) => box.checked).map((box) => box.value))
    const matching = this.pillTargets.filter((pill) => this.idList(JSON.parse(pill.dataset.checks)) === ticked)
    const lit = matching.find((pill) => pill.dataset.groupId === this.startingGroupId) || matching[0]
    this.pillTargets.forEach((pill) => {
      const link = pill.querySelector("a")
      pill.classList.toggle("active", pill === lit)
      if (pill === lit) {
        link.setAttribute("aria-current", "true")
      } else {
        link.removeAttribute("aria-current")
      }
    })
    this.groupIdTarget.value = lit ? lit.dataset.groupId : this.startingGroupId
  }

  idList(ids) {
    return ids.map(String).sort().join(",")
  }
}
